<template>
	<div>
	  <h2 class="mb-2">{{ $t("unmapped-learning-outcomes") }}</h2>
	  <div class="row align-items-start">
		<div class="col-12 col-md-3">
		  <MultiselectSearchInput
			:label="$t('curricula')"
			v-model="filters.root_ids"
			:options="programmes"
			optionLabel="title"
			optionValue="id"
			@input="value => refresh({ root_ids: value })"
		  />
		</div>
		<div class="col-12 col-md-3">
		  <MultiselectSearchInput
			:label="$t('learning-outcome-groups')"
			v-model="filters.group_ids"
			:options="groups"
			optionLabel="title"
			optionValue="id"
			@input="value => refresh({ group_ids: value })"
		  />
		</div>
		<div class="col-12 col-md-3">
		  <div class="form-group">
			<label aria-hidden="true" class="d-block invisible">&nbsp;</label>
			<SearchBar
			  v-model="filters.search"
			  :placeholder="$t('search')"
			  @input="value => refresh({ search: value })"
			/>
		  </div>
		</div>
        <!-- <div class="col-12 col-md-3">

          
		  <YesNoToggle
            :yesLabel="$t('yes')"
            :noLabel="$t('no')"
            :noFirst="true"
            :label="$t('display-linked-outcomes')"
            v-model="filters.include_linked"
            @input="value => refresh({ include_linked: value })"
          />
		</div> -->
	  </div>
  
	  <div v-if="loaded && learningoutcomes?.length > 0" class="list-group">
		<div class="list-group-item d-none d-sm-inline">
		  <div class="row">
			<div class="col-12 col-sm-4 font-bold">{{ $t("name") }}</div>
		  </div>
		</div>
		<div
		  class="list-group-item"
		  v-for="outcome in learningoutcomes"
		  :key="outcome.id"
		  @click="selectOutcome(outcome.id)"
		  @contextmenu.prevent="deletingOutcome = outcome.id"
		>
		  <p class="mb-0">{{ outcome.code ? `${outcome.code}: ` : ''}}{{ outcome.title }}</p>
		  <p class="mb-0">{{ outcome.note || $t('no-notes') }}</p>
		  <p class="mb-0 text-muted" v-if="outcome.linked_to">
		    <small>{{ $t('linked-to') }}: {{ outcome.linked_to.code ? `${outcome.linked_to.code}: ` : '' }}{{ outcome.linked_to.title }}</small>
		  </p>
		</div>
	  </div>
  
	  <div class="card text-center" v-else-if="loaded">
		<div class="card-body">
		  <p class="mb-0">{{ $t('none') }}</p>
		</div>
	  </div>
  
	  <table v-else class="table">
		<tr v-for="n in 5" :key="n">
		  <td>
			<div class="skeleton midnight h16 w-half"></div>
		  </td>
		</tr>
	  </table>
	</div>
</template>
  
<script>
import SearchBar from "src/components/Table/SearchBar.vue";
import SessionManager from "src/modules/session/sessionManager.js";
//import YesNoToggle from "../../../components/Inputs/YesNoToggle.vue";

  export default {
	components: { SearchBar },

	data() {
	  return {
		loaded: false,
		learningoutcomes: [],
		programmes: [],
		groups: [],
		filters: {
		  unmapped: true,
		  search: null,
		  root_ids: [],
		  group_ids: [],
          include_linked: false
		},

	  };
	},

	mounted() {
	  this.sessionManager = new SessionManager(this.$route);
	  const saved = this.sessionManager.get('unmapped-filters');
	  if (saved) this.filters = { ...this.filters, ...saved };
	  this.getProgrammes();
	  this.getOutcomeGroups();
	  this.getLearningOutcomes();
	},

	methods: {
	  getProgrammes() {
		this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/listroots`, {
		  method: "post"
		})
		.then(res => {
		  if (res.status === "SUCCESS") {
			this.programmes = res.results;
		  }
		})
		.catch(err => this.$log.error.call(this, err));
	  },
  
	  getOutcomeGroups() {
		this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/group/list`, {
		  method: "post",
		  data: {}
		})
		.then(res => {
		  if (res.status === "SUCCESS" && Array.isArray(res.results)) {
			this.groups = res.results;
		  }
		})
		.catch(err => this.$log.error.call(this, err));
	  },
  
	  getLearningOutcomes() {
		this.loaded = false;
		this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/list`, {
		  method: "post",
		  data: this.filters
		})
		.then(res => {
		  if (res.status === "SUCCESS") {
			this.learningoutcomes = res.results;
		  }
		})
		.catch(err => this.$log.error.call(this, err))
		.finally(() => {
		  this.loaded = true;
		});
	  },
  
	  refresh(filters) {
		this.filters = { ...this.filters, ...filters };
		this.sessionManager.set('unmapped-filters', this.filters);
		this.getLearningOutcomes();
	  },
  
	  selectOutcome(id) {
		if (!this.$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')) return;
		this.$router.push(`/curriculum-mapping/learning-outcomes/edit/${id}`);
	  }
	}
  };
</script>